import DefaultActionTypes from "./action-types";

const initState = {
    closePacModal: false,
    fullScreenPacModal: false,
    initCall: null,
    openChatAssistente: null
}

const defaultReducer = (state = initState, action) => {
    switch (action.type) {
        case DefaultActionTypes.CLOSE_PACIENTE_MODAL:
            return { ...state, closePacModal: action.payload };

        case DefaultActionTypes.INIT_CALL:
            return { ...state, initCall: action.payload };

        case DefaultActionTypes.OPEN_CHAT_ASSISTENTE:
            return { ...state, openChatAssistente: action.payload };

        case DefaultActionTypes.FULL_SCREEN_PACIENTE_MODAL:
            return { ...state, fullScreenPacModal: action.payload };

        default: return state;
    }
}

export default defaultReducer;